import { useDispatch, useSelector } from 'react-redux'
import { setFilterProvider } from 'Redux/carts/actions'

const useCartsProviderFilter = () => {
  const dispatch = useDispatch()

  const value = useSelector(state => state.carts.filterProviders)

  const onChange = providers => dispatch(setFilterProvider(providers))

  return { value, onChange }
}

export default useCartsProviderFilter
